export default __webpack_public_path__ + "static/media/icon.0901645d.png";